import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Common/withRouter";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";
import user2 from "../../../assets/images/man_2202112.png";
import { GetCookieData } from "../../../pages/Cookie/GetCookie";
import manProfile from "../../../assets/images/man_profile.png"
import womanProfile from "../../../assets/images/woman_profile.png"

const ProfileMenu = props  => {
  const API_URL = process.env.REACT_APP_API_CORS;
  const navigate = useNavigate()

  const user = GetCookieData("userData")
  const user_name = user.user_name
  const user_gender = user?.user_title_name

  const [menu, setMenu] = useState(false);
  const [username, setusername] = useState(user_name);

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.username);
      }
    }
  }, [props.success]);

  const checkPicNullAndGender = (gender) => {
    if(!props?.picture && (gender === "นาย")) return manProfile
    if(!props?.picture && (gender === "นาง")) return womanProfile
    if(!props?.picture && (gender === "นางสาว")) return womanProfile
    else {
      if (props?.picture && props?.picture.startsWith("./public")) {
        return API_URL + props?.picture.replace("./public", "")
      } else {
        return props?.picture
      }
    }
  }

  return (
    <React.Fragment>
      <Dropdown
        style={{cursor: "default"}}
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
        style={{cursor: "default"}}
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={checkPicNullAndGender(user_gender)}
            // src={user2}
            alt="Header Avatar"
          />
          <span className="d-none d-sm-inline-block ms-2 me-1">{username}</span>
          {/* <i className="mdi mdi-chevron-down d-none d-xl-inline-block" /> */}
        </DropdownToggle>
        {/* <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="/profile">
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>
          <DropdownItem tag="a" href="#">
            <span className="badge bg-success float-end">11</span>
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {props.t("Settings")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/login" className="dropdown-item" onClick={() => {
            handleLogout("userData","userToken")
          }}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu> */}
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

// const mapStatetoProps = state => {
//   const { error, success } = state.Profile;
//   return { error, success };
// };

export default withRouter(
  connect()(withTranslation()(ProfileMenu))
  // connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
